<template>
  <div :style="'width:' + getWidth(col) ">
    <el-button type="text" @click="jumpPage(col, index)" v-if="col.deal_type == LINK_JUMP">{{ row[col.field_name] }}</el-button>
    <el-button type="text" @click="downloadItem(col, index)" v-else-if="col.deal_type == LINK_DOWNLOAD">下载</el-button>
    <el-button type="text" @click="sendParams(col, index)" v-else-if="col.deal_type == LINK_SENDPARAMS">{{ row[col.field_name] }}</el-button>
    <el-button type="text" @click="showRelate(col, index)" v-else-if="col.deal_type == LINK_SHOWRELATE || col.deal_type == LINK_SUBRELATE">{{ row[col.field_name].length }}</el-button>
    <div class="imgContent" v-else-if="col.deal_type == IMG_SHOW && row[col.field_name]">
      <div :class="{isShowBig:(row[col.field_name].listImgShow?row[col.field_name].listImgShow:false)}">
        <img :src="row[col.field_name].deal_image" alt="" :style="row[col.field_name].list_display" @mouseenter="enterImg(row[col.field_name].deal_image, row[col.field_name].listImgShow)" @mouseleave="leaveImg">
      </div>
    </div>
    <span v-else>{{ row[col.field_name] }}</span>
  </div>
</template>

<style scoped>
  .isShowBig{
    cursor: pointer;
  }
  .imgContent:hover .bigImg{
    display:block;
  }
  .bigImg{
    position: absolute;
    z-index: 99999;
    left: 20px;
    top: 77px;
  }
</style>

<script>
  import cmsConfig from '../../../config/cmsConfig'
  export default {
    props: {
      col: {
        type: Object,
        default() {
          return {}
        }
      },
      index: {
        type: Number,
        default() {
          return 0
        }
      },
      row: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    data() {
      return {
      }
    },
    methods: {
      jumpPage(col, index) {
        this.$emit('jumpPage', col, index)
      },
      downloadItem(col, index) {
        this.$emit('downloadItem', col, index)
      },
      sendParams(col, index) {
        this.$emit('sendParams', col, index)
      },
      showRelate(col, index) {
        this.$emit('showRelate', col, index)
      },
      enterImg(img, flag) {
        this.$emit('enterImg', img, flag)
      },
      leaveImg() {
        this.$emit('leaveImg')
      },
      getWidth(col) {
        let width = ''
        if (col.width && this.windowWidth) {
          width = `${col.width / 12 * this.windowWidth}`
        }
        return width
      }
    },
    mixins: [cmsConfig]
  }
</script>


// WEBPACK FOOTER //
// listCol.vue?0cb994f9